import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/table";
import ExportCSV from "./ExportCSV";
import API_BASE_URL from "../config";

function ProjectTable({ reload }) {
  const [projects, setProjects] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    fetch(API_BASE_URL + "/api/project")
      .then((res) => res.json())
      .then((data) => setProjects(data.projects))
      .catch((err) => console.error("Error fetching project:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No Project Found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Division List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={projects.map((item, index) => [
            item.name,
            item.initial,
            item.division,
            item.range,
            item.startDate,
            item.endDate,
            item.status,
          ])}
          header={[
            "NAME",
            "INITIAL",
            "DIVISION",
            "RANGE",
            "START DATE",
            "END DATE",
            "STATUS",
          ]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>NAME</th>
            <th>INITIAL</th>
            <th>DIVISION</th>
            <th>RANGE</th>
            <th>START DATE</th>
            <th>END DATE</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {projects.map((item, index) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.initial}</td>
              <td>{item.division}</td>
              <td>{item.range}</td>
              <td>{new Date(item.startDate).toLocaleDateString("en-GB")}</td>
              <td>{new Date(item.endDate).toLocaleDateString("en-GB")}</td>
              <td>{item.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProjectTable;
